import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "oxd-table-card-cell-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_checkbox_input = _resolveComponent("oxd-checkbox-input")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
    class: "oxd-table-card-cell-checkbox"
  }, [
    (_ctx.isSelectable)
      ? (_openBlock(), _createBlock(_component_oxd_checkbox_input, {
          key: 0,
          modelValue: _ctx.checkState,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkState) = $event)),
          value: _ctx.item,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickCheckbox(_ctx.item, $event))),
          disabled: _ctx.isDisabled
        }, null, 8, ["modelValue", "value", "disabled"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_oxd_checkbox_input)
        ]))
  ]))
}